<template>
    <section class="main-board policy-board">
        <div class="policy_undcontainer">
            <div class="container">
                <perfect-scrollbar>
                    <div class="policy-cover">
                        <h3>ДОГОВІР-ОФЕРТА НАДАННЯ ПОСЛУГ З ДОСТУПУ ТА ВИКОРИСТАННЯ СЕРВІСУ ADS QUIZ</h3>
                        <h4>1. ЗАГАЛЬНІ ПОЛОЖЕННЯ</h4>
                        <p>1.1. Цей Договір являється офіційною офертою (пропозицією) Фізичної особи-підприємця Палія Олександра
                            Васильовича, ІПН
                            337001092, зареєстрованого згідно законодавства України, іменований надалі «Виконавець», необмеженому
                            колу осіб –
                            «Замовникам», укласти Договір по наданню послуг з доступу та використання сервісу ADS QUIZ в мережі
                            Інтернет та інших
                            супутніх до цього послуг.</p>
                        <p>1.2. У відповідності до ст. 633, 641 Цивільного кодексу України, умови Договору являються публічними та
                            однаковими для
                            всіх Замовників, незалежно від статусу (фізична особа, юридична особа, фізична особа-підприємець). За
                            цілковитою згодою
                            з Договором Замовник приймає умови та порядок оформлення замовлення, оплати Послуг та відповідальність
                            за невиконання
                            умов цього Договору.</p>
                        <p>1.3. Повним і беззастережним акцептом оферти вважаються будь-які дії щодо виконання зазначених у цьому
                            Договорі умов, в
                            тому числі оплата Послуг, реєстрація на Веб сайті Виконавця, а також інші дії, що підтверджують наміри
                            особи
                            користуватися Сервісом і/або Послугами.</p>
                        <p>1.4. Цей Договір набирає сили з моменту його акцепту Замовником.</p>
                        <br><br>
            
                        <h4>2. ТЕРМІНИ ТА ВИЗНАЧЕННЯ</h4>
                        <p>2.1. З метою належного виконання цього Договору, нижченаведені терміни використовуються в наступних
                            значеннях:</p>
                        <p><span style="padding-left: 15px;"> </span>• Авторизація — процес аналізу на сервері Виконавця введених
                            Замовником аутентифікаційних даних, за результатами якого
                            визначається наявність у Замовника права отримати Послугу.</p>
                        <p><span style="padding-left: 15px;"> </span>• Аутентифікаційні дані — унікальний логін (login) і пароль
                            (password) Клієнта, які використовуються для доступу до
                            Послуги, зазначені Замовником при реєстрації на сервісі.</p>
                        <p><span style="padding-left: 15px;"> </span>• Замовник— фізична і/або юридична особа і/або ФОП, яка
                            прийняла умови цієї оферти і/або користується Сервісом.</p>
                        <p><span style="padding-left: 15px;"> </span>• Облікові дані — адреса електронної пошти Замовника, пароль,
                            прізвище та ім'я.</p>
                        <p><span style="padding-left: 15px;"> </span>• Послуга — підключення на певний термін додаткових
                            функціональних можливостей Сервісу, відповідно до Прайс-листа і
                            умовами даної оферти.</p>
                        <p><span style="padding-left: 15px;"> </span>• Прайс-лист — діючий систематизований перелік послуг Виконавця
                            з цінами та тарифами, що публікується в мережі Інтернет
                            на Веб сайті Виконавця.</p>
                        <p><span style="padding-left: 15px;"> </span>• Сервіс та/або Квіз — Веб сайт Виконавця, розміщений в мережі
                            Інтернет за адресою <a href="https://adsquiz.io">https://adsquiz.io/</a>, а також
                            будь-які інші веб сайти Виконавця.</p>
                        <br><br>
            
                        <h4>3. ПРЕДМЕТ ДОГОВОРУ</h4>
                        <p>3.1. Виконавець зобов’язується надати Замовнику Послуги з надання доступу та використання сервісу ADS
                            QUIZ на Веб сайті
                            Виконавця в мережі Інтернет та інших супутніх до цього послуг, а Замовник зобов’язується прийняти та
                            сплатити такі
                            Послуги (надалі «Послуги»).</p>
                        <p>3.2. Інформація стосовно повного переліку та наповнення Послуг розміщується на Сервісі Виконавця та
                            являється
                            невід’ємною частиною даного Договору.</p>
                        <p>3.3. Послуги надаються на умовах, визначених в цьому Договорі, які Виконавець має право змінити або
                            доповнити в
                            будь-який момент з повідомленням Замовників, або без нього.</p>
                        <p>3.4. Чинна редакція Договору розміщена на Веб сайті Виконавця за адресою <a
                                href="https://adsquiz.io">https://adsquiz.io/</a>.</p>
                        <br><br>
            
                        <h4>4. ПРАВА ТА ОБОВ'ЯЗКИ ВИКОНАВЦЯ</h4>
                        <p>4.1. Виконавець зобов'язується:</p>
                        <p><span style="padding-left: 15px;"> </span>4.1.1. Забезпечувати роботу Сервісу, відповідно до цього
                            Договору, цілодобово 7 днів на тиждень, включаючи вихідні та
                            святкові дні (сервіс повинен бути доступний не менше 90% часу в місяць), за винятком випадків
                            обумовлених в цьому
                            Договорі.</p>
                        <p><span style="padding-left: 15px;"> </span>4.1.2. Вести облік оплати Замовником Послуг.</p>
                        <p><span style="padding-left: 15px;"> </span>4.1.3. Дотримуватися конфіденційності облікових даних
                            Замовника. Виконавець має доступ до інформації Замовника з метою
                            технічного забезпечення роботи Сервісу, а також має право на доступ до такої інформації у випадках
                            отримання претензій
                            від третіх осіб, що стосуються протизаконних та/або шкідливих, а також інших дій Замовника, що завдають
                            шкоди Виконавцю
                            та/або третім особам. Виконавець має право повідомити вищезгадані дані тільки компетентним державним
                            органам у випадках,
                            передбачених чинним законодавством України.</p>
                        <p><span style="padding-left: 15px;"> </span>4.1.4. Резервне копіювання даних Замовника в цілях запобігання
                            втрати інформації не є порушенням конфіденційності
                            інформації Замовника.</p>
                        <p>4.2. Виконавець має право:</p>
                        <p><span style="padding-left: 15px;"> </span>4.2.1. Припиняти роботу Сервісу для проведення необхідних
                            планових профілактичних і ремонтних робіт на технічних
                            ресурсах Виконавця, а також позапланових робіт в аварійних ситуаціях.</p>
                        <p><span style="padding-left: 15px;"> </span>4.2.2. Переривати роботу Сервісу, якщо це, зокрема, обумовлено
                            неможливістю використання інформаційно-транспортних
                            каналів, які не є власними ресурсами Виконавця, або дією і/або бездіяльністю третіх осіб, якщо це
                            безпосередньо впливає
                            на роботу Сервісу, в тому числі при аварійній ситуації. Виконавець не несе будь-якої відповідальності
                            перед Замовником і
                            не відшкодовує Замовнику будь-які збитки і/або втрачений прибуток, в т.ч. понесений Замовником та/або
                            третіми особами
                            через розголошення, втрати Замовником або крадіжки у Замовника облікових даних, а також що виникли або
                            можуть виникнути
                            у Замовника у зв'язку із затримками, перебоями в роботі і неможливістю повноцінного використання
                            ресурсів і Послуг
                            Виконавця, що виникли з перерахованих вище причин.</p>
                        <p><span style="padding-left: 15px;"> </span>4.2.3. Вносити зміни і доповнення до положень цього Договору і
                            Прайс-листа шляхом публікації цих змін і доповнень на Веб
                            сайті Сервісу.</p>
                        <p><span style="padding-left: 15px;"> </span>4.2.4. Виконавець має право оновлювати зміст, функціональні
                            можливості і призначений для користувача інтерфейс Сервісу в
                            будь-який час на свій власний розсуд.</p>
                        <p><span style="padding-left: 15px;"> </span>4.2.5. Після закінчення 1 (одного) календарного місяця з
                            моменту розірвання або припинення терміну дії Договору
                            Виконавець має право видалити всі дані Замовника з Сервісу без можливості відновлення і звільняється від
                            будь-яких
                            зобов'язань, пов'язаних з Даними Замовника.</p>
                        <p><span style="padding-left: 15px;"> </span>4.2.6. Виконавець має право посилатися на Замовника, як на
                            користувача Сервісу і/або Послуг, в будь-якій формі і на
                            будь-якому носії (в т.ч. на сайті Сервісу і будь-яких інших сайтах і/або в рекламних матеріалах
                            Виконавця).</p>
                        <br><br>
            
                        <h4>5. ВАРТІСТЬ ПОСЛУГ І ПОРЯДОК РОЗРАХУНКІВ</h4>
                        <p>5.1. Розмір плати за Послуги та їх ціна визначається Виконавцем в односторонньому порядку та розміщується
                            на Сервісі
                            Виконавця у вигляді тарифів, що передбачають різний об’єм та наповнення Послуг.</p>
                        <p>5.2. Виконавець має право в будь-який час в односторонньому порядку змінювати Прайс-лист.</p>
                        <p>5.3. Послуги оплачуються Замовником на умовах передоплати, при цьому спосіб здійснення передоплати Послуг
                            визначається
                            Замовником самостійно з числа варіантів, запропонованих на сайті Сервісу.</p>
                        <p>5.4. Якщо при використанні Сервісу Замовник перевищує обсяг Послуг за вибраним та сплаченим тарифом, то
                            вартість Послуг,
                            отриманих понад сплачений тариф, підлягає сплаті додатково шляхом списання коштів з рахунку Замовника,
                            якщо дана функція
                            доступна та була підключена Замовником. В іншому випадку, доступ до Сервісу може бути обмежено до
                            моменту сплати, або
                            відключено, відповідно до п.6.4. Договору. Замовник повідомляється про перевищення обсягу Послуг за
                            обраним тарифом в
                            особистому кабінеті.</p>
                        <p>5.5. При виборі функції автоматичної оплати, плата списується з рахунку Замовника у розмірі та після
                            закінчення періоду,
                            визначеного обраним тарифом. Функції автоматичної оплати (автоматичне продовження оплати) продовжують
                            діяти до моменту,
                            поки Замовник не відключить цю функцію в особистому кабінеті Замовника. Несвоєчасне відключення функції
                            автоматичної
                            оплати не є підставою для повернення списаних коштів Замовнику.</p>
                        <p>5.6. Датою надання Послуг Виконавцем є дата здійснення підключення (продовження) на певний термін
                            додаткових
                            функціональних можливостей Сервісу.</p>
                        <br><br>
            
                        <h4>6. ПОРЯДОК НАДАННЯ ПОСЛУГ</h4>
                        <p>6.1 Виконавець на строк дії Договору надає Замовнику не ексклюзивне право доступу до Сервісу, що не
                            підлягає передачі
                            або відчуженню в будь-якій формі, та має обмежений термін дії виключно для ділових операцій Замовника,
                            які не
                            передбачають здачу Сервісу в оренду.</p>
                        <p>6.2 Доступ Замовника до Сервісу здійснюється в мережі Інтернет за допомогою введення Замовником
                            аутентифікаційних даних
                            за адресою Сервісу.</p>
                        <p>6.3 Надання Послуг здійснюється після зарахування грошових коштів на банківський рахунок Виконавця.</p>
                        <p>6.4 Після закінчення періоду, на який було здійснено підключення додаткових функціональних можливостей
                            Сервісу,
                            Виконавець відключає додаткові функціональні можливості Сервісу.</p>
                        <p>6.5 Звітний період надання Послуг встановлюється в Прайс-листі.</p>
                        <p>6.6 Здача-приймання послуг проводиться в наступному порядку:</p>
                        <p><span style="padding-left: 15px;"> </span>6.6.1. Протягом п'яти робочих днів з моменту надання Послуг
                            (підключення на певний термін додаткових функціональних
                            можливостей Сервісу, відповідно до прайс-листа і умовами Договору) Виконавець формує односторонній Акт
                            про надані
                            послуги відповідно до вартості наданих послуг.</p>
                        <p><span style="padding-left: 15px;"> </span>6.6.2. Послуги вважаються наданими Виконавцем належним чином і
                            прийнятими Замовником в зазначеному в Акті обсязі, якщо
                            протягом п'яти робочих днів з моменту виставлення Акта Виконавець не отримав від Замовника мотивованих
                            письмових
                            заперечень.</p>
                        <p>6.7. Після закінчення терміну, зазначеного вище (п'яти робочих днів), претензії Замовника щодо недоліків
                            Послуг, в тому
                            числі за кількістю (об'ємом), вартості та якості не приймаються.</p>
                        <p>6.8. Витрати, в тому числі банківська комісія, по перерахуванню Замовником грошових коштів за даним
                            Договором
                            покладаються на Замовника.</p>
                        <br><br>
            
                        <h4>7. ПРАВИЛА ВИКОРИСТАННЯ СЕРВІСУ</h4>
                        <p>7.1. Реєстрація в сервісі здійснюється Замовником самостійно шляхом зазначення своїх Облікових даних.
                            Елементами, що
                            ідентифікують Замовника в Сервісі, є адреса електронної пошти та пароль, вказані при реєстрації
                            (облікові дані).</p>
                        <p>7.2. Адреса електронної пошти та пароль, які використовуються Замовником для доступу до Сервісу,
                            Виконавцем не
                            відновлюються. Відновлення пароля здійснюється Замовником самостійно.</p>
                        <p>7.3. Замовник несе повну відповідальність за дії і/або бездіяльність, що призвели до розголошення,
                            втрати, крадіжки і
                            т.п. його облікових даних та іншої інформації, індивідуалізуючої Замовника, а також за будь-які дії
                            та/або бездіяльність
                            третіх осіб, що використовують облікові дані Замовника. Виконавець не несе відповідальності за
                            вищевказані дії Замовника
                            та/або третіх осіб, що використовують його облікові дані.</p>
                        <p>7.4. При використанні Сервісу забороняються будь-які дії, спрямовані на отримання несанкціонованого
                            доступу до ресурсів
                            сервера Виконавця, персональних облікових і інших даних інших клієнтів, а також будь-яким іншим даними,
                            доступних через
                            мережу Інтернет.</p>
                        <p>7.5. При використанні Сервісу Замовнику забороняється здійснювати масову розсилку електронних повідомлень
                            комерційного,
                            рекламного та іншого характеру, не погоджених (не запитаних) одержувачем інформації по електронній пошті
                            або в групи
                            телеконференцій через технічні ресурси Виконавця ("спам"). Не розглядається як "спам" розсилка
                            інформації з відома
                            одержувача, при можливості відмови від підписки. Під електронними повідомленнями розуміються
                            повідомлення електронної
                            пошти, ICQ та інших подібних засобів особистого обміну інформацією.</p>
                        <p>7.6. Забороняється проводити масову розсилку "спаму" через ресурси, які не належать Виконавцю, в тому
                            випадку, якщо в
                            повідомленні вказані координати (адреса сайту, електронної пошти і т.д.), підтримувані Виконавцем.</p>
                        <p>7.7. Використання сервісу має здійснюватися Замовником виключно в законних цілях і законними способами з
                            урахуванням
                            законодавства України.</p>
                        <p>7.8. За зміст інформаційних вузлів, що створюються і підтримуються Замовником, несе відповідальність
                            безпосередньо сам
                            Замовник. Виконавець не здійснює попереднього контролю за змістом розміщуваної та/або розповсюджуваної
                            Замовником
                            інформації, проте коли розміщення і розповсюдження такої інформації суперечить законодавству, Виконавець
                            має право
                            заблокувати або видалити відповідні ресурси без попередження (в разі серйозних порушень).</p>
                        <p>7.9. Забороняється розміщення та поширення фото- і відеоматеріалів порнографічного, вульгарного,
                            насильницького
                            характеру, а також будь-яких матеріалів з порушенням авторських прав або законодавства, зокрема, заклики
                            до насильства,
                            повалення існуючої влади, дискримінації за статевою, расовою, релігійною, національною ознаками і т. п.
                        </p>
                        <p>7.10. Забороняється розміщення і розповсюдження будь-якої інформації або програмного забезпечення, яке
                            може бути
                            використано тільки для злому комп'ютерних систем або містить в собі комп'ютерні віруси або інші
                            компоненти, прирівняні
                            до них.</p>
                        <p>7.11. Забороняється розміщення так званих "дорвеев" та інших форм пошукового спаму.</p>
                        <p>7.12. Замовник зобов'язується не завдавати збитку програмній оболонці, технічних і програмних засобів,
                            вузловим машинам
                            Виконавця і третіх осіб.</p>
                        <p>7.13. Замовник зобов'язується дотримуватися авторських прав на надане Виконавцем та й/або третіми особами
                            програмне
                            забезпечення і документацію.</p>
                        <br><br>
            
                        <h4>8. ВІДПОВІДАЛЬНІСТЬ СТОРІН</h4>
                        <p>8.1. Сторони керуються чинним законодавством України в усіх питаннях, не врегульованих у цьому Договорі,
                            а також при
                            вирішенні спорів, що виникли в процесі її виконання.</p>
                        <p>8.2. Замовник несе відповідальність за будь-які свої дії і/або бездіяльність, як умисні, так і
                            ненавмисні, а так само за
                            будь-які дії та/або бездіяльність осіб, що використовують його облікові дані, пов'язані з розміщенням
                            і/або
                            розповсюдженням інформації в мережі Інтернет, отриманням за допомогою використання ресурсів Виконавця
                            доступу до
                            ресурсів третіх осіб, які спричинили і/або можуть спричинити порушення будь-якого законодавства України,
                            а також за
                            будь-які збитки, заподіяний вищезгаданими діями і/або бездіяльністю Виконавцеві, третім особи і
                            моральним засадам
                            суспільства. Виконавець не несе відповідальності за такі дії і/або бездіяльність Замовника або осіб, що
                            використовують
                            його облікові дані, а також наслідки таких дій і/або бездіяльності.</p>
                        <p>8.3. Замовник несе відповідальність за будь-які неправомірні дії та/або бездіяльність Замовника та/або
                            осіб, що
                            використовують його облікові дані, що призвели до заподіяння будь-якої шкоди Виконавцю, включаючи втрату
                            ділової
                            репутації, і відшкодовує Виконавцю збитки.</p>
                        <p>8.4. Виконавець несе відповідальність перед Замовником виключно в межах сплачених, але не наданих Послуг.
                            Виконавець не
                            несе перед Замовником фінансової відповідальності і не повертає Замовнику сплачені за цим Договором
                            грошові кошти, в
                            разі якщо Послуги були надані з вини Замовника унаслідок порушення Договору.</p>
                        <p>8.5. У разі якщо належне виконання Сторонами цього Договору неможливе в силу об'єктивних причин, які
                            Сторони не могли ні
                            передбачити, ні запобігти (стихійні лиха, зміни поточного законодавства України, дії органів державної
                            влади та
                            управління, військові дії всіх видів і т. п.), жодна зі сторін не має права вимагати від іншої сторони
                            відшкодування
                            заподіяних неналежним виконанням або невиконанням цього Договору збитків (включаючи упущену вигоду).</p>
                        <br><br>
            
                        <h4>9. РОЗІРВАННЯ ДОГОВОРУ</h4>
                        <p>9.1. Договір може бути розірваний:</p>
                        <p><span style="padding-left: 15px;"> </span>9.1.1. Замовником в будь-який час з попереднім повідомленням
                            Виконавця не менше ніж за 1 (один) робочий день до моменту
                            розірвання.</p>
                        <p><span style="padding-left: 15px;"> </span>9.1.2. Виконавцем в будь-який час з попереднім повідомленням
                            Клієнта не менше ніж за 1 (один) робочий день до моменту
                            розірвання.</p>
                        <p><span style="padding-left: 15px;"> </span>9.1.3. За згодою Сторін в будь-який час.</p>
                        <p><span style="padding-left: 15px;"> </span>9.1.4. За ініціативою однієї зі Сторін в разі порушення іншою
                            Стороною умов Договору з письмовим повідомленням іншої
                            Сторони не менше ніж за 1 (один) робочий день до розірвання Договору.</p>
                        <br><br>
            
                        <h4>10. ЗАКЛЮЧНІ УМОВИ</h4>
                        <p>10.1. Виконавець має право при необхідності залучати для надання Послуг і забезпечення роботи Сервісу
                            третіх осіб, що
                            мають відповідні ліцензії.</p>
                        <p>10.2. У разі якщо дія Замовника стала підставою для пред'явлення до Виконавця претензій, позовів третіх
                            осіб і/або
                            розпоряджень щодо сплати штрафних санкцій з боку державних органів у зв'язку з порушенням прав третіх
                            осіб і/або
                            законодавства, Замовник зобов'язується негайно на вимогу Виконавця надати йому всю запитувану
                            інформацію, що стосується
                            розміщення та змісту матеріалів, використовуваних в сервісі, сприяти Виконавцю у врегулюванні таких
                            претензій і позовів,
                            а також відшкодувати всі збитки, завдані Виконавцю внаслідок пред'явлення йому таких претензій, позовів,
                            приписів.</p>
                        <p>10.3. Спори та суперечки, які не були врегульовані в позасудовий спосіб, вирішуються в судовому порядку
                            за місцем
                            знаходження Виконавця, відповідно до інформації, що міститься в ЄДР.</p>
                        <br><br><br>
            
                        <p>ФОП Палій Олександр Васильович, ІПН 337001092</p>
                        <p>Україна, Полтавська обл., місто Кременчук, Вул. Шишкіна</p>
                        <p>Email - info@adsquiz.io</p>
                    </div>
                </perfect-scrollbar>
            </div>
        </div>
        
    </section>
</template>

<script>
export default {
    data() {
        return {
            baseBackendUrl: process.env.VUE_APP_BASE_URL,
            opacityBody: '0',
        }
    },
    computed: {
        curentQuizURL() {
            return window.location.href
        },
        subDomain() {
            return this.curentQuizURL.split('/')[2]
        },
        isAdsquizSubdomain() {
            if (this.subDomain.split('.')[1] == 'adsquiz') {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        
    },
    mounted() {
        
    },
}
</script>

<style scoped>
.policy-board {
    height: 100vh;
    min-height: 100vh;
    max-height: 100vh;
    background: #FFF;
    /* padding: 40px 0; */
}
.policy_undcontainer {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
}
.main-board.policy-board .container {
    height: calc(100% - 2px);
    padding-top: 1px;
}
.policy-cover {
    padding: 40px;
    background: #FFF;
    margin: 0 auto;
    width: 100%;
    max-width: 1000px;
    /* height: 100% */
}

.policy-cover .ps {
    width: 100%;
    max-width: 1000px;
    padding-right: 25px;
    margin: 0 auto;
    box-shadow: 4px 4px 20px 5px rgba(0, 0, 0, 0.2);
}

h4 {
    margin-top: 40px;
    margin-bottom: 15px;
}

p {
    margin-bottom: 5px;
}
</style>